import { Component } from "react";


class Footer extends Component {
    render() {
        return (<div>
            Mohamed Ben Amar
        </div>)
    }
}

export default Footer;